var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showFlag,
            expression: "showFlag"
          }
        ],
        staticClass: "c-process"
      },
      [
        _c("div", { staticClass: "wrap" }, [
          _c(
            "div",
            { staticClass: "item" },
            [
              _c("el-progress", {
                attrs: {
                  "text-inside": true,
                  "stroke-width": 18,
                  percentage: _vm.percentage
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "item" }, [_vm._v(_vm._s(_vm.text))])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e4acb6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e4acb6c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base/progressGlobal/progressGlobal.vue
// module id = null
// module chunks = 